export default __webpack_public_path__ + "static/media/white-play-10px-over.ebe01e4a.svg";